import React from 'react'
import { translate } from 'react-i18next'
import './index.sass'

const SimpleTextContent = ({ t, arrText }) => {
  if (!arrText) return null
  return (
    <div className="simple-text-content">
      {arrText.map(text => (
        <p key={text} className="body-light">
          {t(`serviceDetails.${text}`)}
        </p>
      ))}
    </div>
  )
}

export default translate('translations')(SimpleTextContent)
